<template>
  <div class="about">
    <div class="image pt3-l w-100 w-30-l center">
    	<img class="br4" src="/static/assets/danielle_bw.jpg" />
    </div>
    <div class="f3 f2-l fw3 fw2-l tc pt3 ph3 ph5-l pt4-l">
    	Danielle Hayman
    </div>
    <div class="pt1 f4 f3-l fw2 fw2-l tc ">
      Senior Project Manager
    </div>
    <div class="pt1 f5 f3-l fw2 fw2-l tc ">
      Founder
    </div>
    <div class="fw3 f5 f4-l tj w-80 w-50-l center ma4">
		Danielle is a graduate with Honors from California State University, Northridge with a degree in Interior Architecture and Design. Danielle has worked on the development of many multi–use projects and has overseen development in multi–family (both apartment and condo conversions), luxury single family dwellings and commercial centers throughout Southern California. 
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/About.vue